import React, { useEffect, useState } from 'react';
import Footer from './Footer';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import api from '../api';
import Swal from 'sweetalert2';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
// import invoiceLogo from '..//img/logo/logo.png';
// import invoiceLogo from '../../assets/img/logo/logo.png'; 
const OrderList = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const oredrlist = location.state?.orders;
    const [cancel, setCancel] = useState([]);
    const [isVisible, setIsVisible] = useState(false);
    const [showFullAddress, setShowFullAddress] = useState(false);

    console.log("Order Details >>>", oredrlist)

    const steps = ["Order Progress", "Processing", "Shipped", "Out For Delivered", "Delivered"];
    const currentIndex = steps.indexOf(oredrlist?.orderStatus);

    const handleScrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    }, [location.key]);

    useEffect(() => {
        const toggleVisibility = () => setIsVisible(window.pageYOffset > 300);
        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    const storedData = localStorage.getItem("userData");
    const token = storedData ? JSON.parse(storedData).token : null;

    const orderCancel = async (cancelReason) => {
        try {
            const res = await api.post(
                "/user/order/cancel",
                { orderId: oredrlist._id, cancelReason },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setCancel("success", res.data);
            Swal.fire("Cancelled!", "Your order has been cancelled.", "success");
            navigate('/my-orders');
        } catch (error) {
            console.error("Error cancelling order:", error.message);
            Swal.fire("Error", "Order cannot be cancelled as it is already Cancelled", "error");
        }
    };

    const handleCancelOrder = () => {
        Swal.fire({
            title: "Cancel Order",
            input: "text",
            inputLabel: "Reason for cancelling your order",
            inputPlaceholder: "Enter reason...",
            showCancelButton: true,
            confirmButtonText: "Yes, cancel it!",
            cancelButtonText: "No, keep it",
        }).then((result) => {
            if (result.isConfirmed) {
                orderCancel(result.value);
            } else if (result.isDismissed) {
                Swal.fire("Kept!", "Your order is safe 🙂", "info");
            }
        });
    };

    // ── Helper: fetch image → base64 ──────────────────────────
    const getBase64FromUrl = (url) =>
        new Promise((resolve, reject) => {
            fetch(url)
                .then(res => res.blob())
                .then(blob => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result);
                    reader.onerror = reject;
                    reader.readAsDataURL(blob);
                })
                .catch(reject);
        });

    // ── Invoice handler ───────────────────────────────────────
    const handleDownloadInvoice = async () => {
        const doc = new jsPDF();

        const gold = [193, 154, 57];
        const black = [20, 20, 20];
        const white = [255, 255, 255];
        const lightGray = [245, 245, 245];
        const darkGray = [80, 80, 80];
        const pageW = 210;

        // ── Logo ─────────────────────────────────────────────
        try {
            const logoBase64 = await getBase64FromUrl(
                process.env.PUBLIC_URL + '/assets/img/logo/logo.png'  // correct path
            );
            doc.addImage(logoBase64, 'PNG', 10, 6, 38, 20);
        } catch (e) {
            console.warn('Logo not loaded:', e);
        }

        // ── Title (top-right) ─────────────────────────────────
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(9);
        doc.setTextColor(...darkGray);
        doc.text('E-COMMERCE', pageW - 13, 12, { align: 'right' });

        doc.setFont('helvetica', 'bold');
        doc.setFontSize(18);
        doc.setTextColor(...gold);
        doc.text('ORDER INVOICE', pageW - 13, 22, { align: 'right' });

        // ── Gold Rule ─────────────────────────────────────────
        doc.setDrawColor(...gold);
        doc.setLineWidth(0.5);
        doc.line(13, 30, pageW - 13, 30);

        // ── Sold By (left) ────────────────────────────────────
        doc.setFontSize(8.5);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(...black);
        doc.text('Sold By:', 13, 38);

        doc.setFont('helvetica', 'bold');
        doc.setFontSize(9);
        doc.text('Overay', 13, 45);

        doc.setFont('helvetica', 'normal');
        doc.setFontSize(8);
        doc.setTextColor(...darkGray);
        const soldByLines = [
            '2nd Floor, 123, Fashion Street',
            'Mumbai, Maharashtra - 400001, India',
            'Email: support@overay.in',
            'Phone: +91 98765 43210',
            'GSTIN: 27ABCDE1234F1Z5',
        ];
        soldByLines.forEach((line, i) => doc.text(line, 13, 51 + i * 5.5));

        // ── Invoice Details (right) ───────────────────────────
        const rightX = 115;
        const colVal = 145;

        const invoiceNo = `ORY-EINV-${(oredrlist?.orderId || '000001').toString().padStart(6, '0')}`;
        const orderNo = `ORY-ORD-${(oredrlist?.orderId || '000001').toString().padStart(6, '0')}`;
        const invoiceDate = oredrlist?.statusHistory?.[0]?.date || 'N/A';
        const orderDate = oredrlist?.statusHistory?.[0]?.date || 'N/A';

        const rawPayment = (oredrlist?.paymentMethod || '').toLowerCase();
        const isCOD = rawPayment.includes('cod') || rawPayment.includes('cash');
        const paymentLabel = isCOD ? 'Cash on Delivery' : 'Online Payment';

        const invoiceRows = [
            ['Invoice No.', invoiceNo],
            ['Order No.', orderNo],
            ['Invoice Date', invoiceDate],
            ['Order Date', orderDate],
            ['Payment Method', paymentLabel],
        ];

        invoiceRows.forEach(([label, value], i) => {
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(8.5);
            doc.setTextColor(...black);
            doc.text(label, rightX, 38 + i * 7);
            doc.setFont('helvetica', 'normal');
            doc.setTextColor(...darkGray);
            doc.text(`: ${value}`, colVal, 38 + i * 7);
        });

        // ── Billing & Shipping Address (fixed layout) ─────────
        const boxTop = 82;
        const boxH = 48;
        const halfW = (pageW - 30) / 2;
        const gap = 4;

        const drawAddressBox = (x, title, lines) => {
            doc.setFillColor(...lightGray);
            doc.setDrawColor(210, 210, 210);
            doc.setLineWidth(0.3);
            doc.rect(x, boxTop, halfW, boxH, 'FD');

            // header bar
            doc.setFillColor(...black);
            doc.rect(x, boxTop, halfW, 9, 'F');
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(8);
            doc.setTextColor(...white);
            doc.text(title, x + 4, boxTop + 6);

            // address lines
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(7.8);
            doc.setTextColor(40, 40, 40);
            let currentY = boxTop + 14;
            const lineHeight = 5;
            lines.forEach((line) => {
                const wrapped = doc.splitTextToSize(line, halfW - 8);
                wrapped.forEach((wl) => {
                    doc.text(wl, x + 4, currentY);
                    currentY += lineHeight;
                });
            });
        };

        const bAddr = oredrlist?.billingAddress || oredrlist?.shippingAddress;
        drawAddressBox(13, 'BILLING ADDRESS', [
            bAddr?.fullName || '',
            bAddr?.houseName || bAddr?.address || '',
            bAddr?.landmark ? `Near: ${bAddr.landmark}` : null,
            `${bAddr?.city || ''}, ${bAddr?.state || ''} - ${bAddr?.pincode || ''}`,
            'India',
            bAddr?.phone ? `Ph: ${bAddr.phone}` : null,
            bAddr?.email ? `Email: ${bAddr.email}` : null,
        ].filter(Boolean));

        const sAddr = oredrlist?.shippingAddress;
        drawAddressBox(13 + halfW + gap, 'SHIPPING ADDRESS', [
            sAddr?.fullName || '',
            sAddr?.houseName || sAddr?.address || '',
            sAddr?.landmark ? `Near: ${sAddr.landmark}` : null,
            `${sAddr?.city || ''}, ${sAddr?.state || ''} - ${sAddr?.pincode || ''}`,
            'India',
            sAddr?.phone ? `Ph: ${sAddr.phone}` : null,
        ].filter(Boolean));

        // ── Items Table ───────────────────────────────────────
        const tableRows = oredrlist?.orderItems?.map((item, i) => [
            i + 1,
            item?.productName || item?.name || 'Product',
            item?.hsnCode || 'N/A',
            item?.variant?.size || 'N/A',
            item?.quantity,
            `Rs.${(item?.price?.discountedPrice || 0).toFixed(2)}`,
            `Rs.${((item?.price?.discountedPrice || 0) * (item?.quantity || 1)).toFixed(2)}`,
        ]);

        autoTable(doc, {
            startY: boxTop + boxH + 6,
            head: [['S.No.', 'Product Name', 'HSN Code', 'Size', 'Qty', 'Unit Price (Rs.)', 'Total (Rs.)']],
            body: tableRows,
            styles: {
                fontSize: 8.5, cellPadding: 3.5, textColor: black, lineColor: [220, 220, 220],
                lineWidth: 0.2,
            },
            headStyles: { fillColor: black, textColor: white, fontStyle: 'bold', fontSize: 8.5 },
            alternateRowStyles: { fillColor: [252, 252, 252] },
            columnStyles: {
                0: { cellWidth: 14, halign: 'center' },
                1: { cellWidth: 55 },
                2: { cellWidth: 22, halign: 'center' },
                3: { cellWidth: 16, halign: 'center' },
                4: { cellWidth: 12, halign: 'center' },
                5: { cellWidth: 33, halign: 'right' },
                6: { cellWidth: 27, halign: 'right' },
            },
            // tableLineColor: [200, 200, 200],
            // tableLineWidth: 0.3,
        });

        const finalY = doc.lastAutoTable.finalY + 8;

        // ── Notes (bottom-left) ───────────────────────────────
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(8.5);
        doc.setTextColor(...black);
        doc.text('Notes:', 13, finalY);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(8);
        doc.setTextColor(...darkGray);
        doc.text('Thank you for shopping with Overay.', 13, finalY + 6);
        doc.text('We hope to see you again!', 13, finalY + 12);


        // ── Price Summary (bottom-right) ──────────────────────
        const sumX = 118;
        const valX = pageW - 13;
        const lh = 7.5;
        let sy = finalY;

        const hasDiscount = (oredrlist?.discountApplied || 0) > 0;
        const cgst = oredrlist?.cgst || 0;
        const sgst = oredrlist?.sgst || 0;

        const summaryRows = [
            { label: 'Subtotal', value: `Rs.${(oredrlist?.itemsSubtotal || 0).toFixed(2)}`, color: darkGray },
            ...(hasDiscount ? [{ label: 'Discount', value: `-Rs.${(oredrlist?.discountApplied || 0).toFixed(2)}`, color: [22, 163, 74] }] : []),
            { label: 'Shipping Charges', value: `Rs.${(oredrlist?.shippingCharge || 0).toFixed(2)}`, color: darkGray },
            ...(cgst > 0 ? [{ label: 'CGST (2.5%)', value: `Rs.${cgst.toFixed(2)}`, color: darkGray }] : []),
            ...(sgst > 0 ? [{ label: 'SGST (2.5%)', value: `Rs.${sgst.toFixed(2)}`, color: darkGray }] : []),
        ];

        summaryRows.forEach(({ label, value, color }, i) => {
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(8.5);
            doc.setTextColor(...color);
            doc.text(label, sumX, sy + lh * i);
            doc.text(value, valX, sy + lh * i, { align: 'right' });
        });

        // Grand Total bar
        const gtY = sy + lh * summaryRows.length + 2;
        doc.setFillColor(...gold);
        doc.rect(sumX - 2, gtY - 5.5, valX - sumX + 4, 10, 'F');
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(9.5);
        doc.setTextColor(...white);
        doc.text('Grand Total', sumX + 1, gtY + 1.5);
        doc.text(`Rs.${(oredrlist?.totalAmount || 0).toFixed(2)}`, valX, gtY + 1.5, { align: 'right' });

        // ── Footer ────────────────────────────────────────────
        const footerBarY = 272;
        doc.setFillColor(...black);
        doc.rect(0, footerBarY, pageW, 16, 'F');
        doc.setTextColor(...white);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(7.5);
        doc.text('www.overay.in', 18, footerBarY + 10);
        doc.text('support@overay.in', pageW / 2, footerBarY + 10, { align: 'center' });
        doc.text('+91 98765 43210', pageW - 18, footerBarY + 10, { align: 'right' });

        doc.setFontSize(8);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(...gold);
        doc.text('Thank you for choosing Overay!', pageW / 2, footerBarY + 22, { align: 'center' });

        doc.save(`Overay-Invoice-${oredrlist?.orderId || 'order'}.pdf`);
    };

    if (!oredrlist) {
        return (
            <main className="main__content_wrapper">
                <div style={{ textAlign: 'center', padding: '60px 20px' }}>
                    <h2>No order data found.</h2>
                    <Link to="/">Go Home</Link>
                </div>
            </main>
        );
    }

    const statusColor = {
        cancelled: '#ef4444',
        processing: '#f59e0b',
        Shipped: '#3b82f6',
        Delivered: '#22c55e',
    };

    return (
        <>
            <style>{`
                /* ============ Overay – Order Details (compact) ============ */
                .od-section { padding: 18px 0 36px !important; }

                .od-wrap {
                    max-width: 1100px;
                    margin: 0 auto;
                    padding: 0 12px;
                }

                /* Desktop grid:
                   items   items   items
                   thanks  thanks  thanks
                   status  address price
                */
                .od-grid {
                    display: grid;
                    grid-template-columns: 210px 1fr 1fr;
                    grid-template-areas:
                        "items  items   items"
                        "thanks thanks  thanks"
                        "status address price";
                    gap: 14px;
                    align-items: start;
                }
                .od-status  { grid-area: status; }
                .od-items   { grid-area: items; }
                .od-address { grid-area: address; }
                .od-price   { grid-area: price; }
                .od-thanks  { grid-area: thanks; }

                /* Mobile order: items → thanks → address → price → status */
                @media (max-width: 820px) {
                    .od-grid {
                        grid-template-columns: 1fr;
                        grid-template-areas:
                            "items"
                            "thanks"
                            "address"
                            "price"
                            "status";
                        gap: 12px;
                    }
                    .od-status { position: static; }
                }

                /* ---- Card ---- */
                .od-card {
                    background: #fff;
                    border: 1px solid #efe6c8;
                    border-radius: 10px;
                    padding: 12px 14px;
                    box-shadow: 0 2px 10px rgba(206, 178, 86, 0.12);
                }
                .od-card-title {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    margin: 0 0 10px;
                    padding-bottom: 8px;
                    border-bottom: 2px solid #ceb256;
                    font-size: 14px;
                    font-weight: 700;
                    color: #1a1a1a;
                }

                /* ---- Status tracker (vertical on desktop) ---- */
                .od-current {
                    background: #014f3c;
                    color: #fff;
                    font-size: 12px;
                    font-weight: 700;
                    padding: 6px 10px;
                    border-radius: 6px;
                    margin-bottom: 12px;
                    word-break: break-word;
                }
                .od-steps { display: flex; flex-direction: column; }
                .od-step {
                    position: relative;
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    padding-bottom: 16px;
                }
                .od-step:last-child { padding-bottom: 0; }
                .od-step::before {              /* connector line */
                    content: "";
                    position: absolute;
                    left: 8px;
                    top: 18px;
                    bottom: 0;
                    width: 2px;
                    background: #e0e0e0;
                }
                .od-step:last-child::before { display: none; }
                .od-step.is-done::before { background: #014f3c; }
                .od-dot {
                    width: 18px; height: 18px;
                    border-radius: 50%;
                    background: #d1d5db;
                    flex-shrink: 0;
                    box-sizing: border-box;
                    z-index: 1;
                    border: 2px solid #fff;
                    box-shadow: 0 0 0 1px #d1d5db;
                }
                .od-step.is-done .od-dot { background: #014f3c; box-shadow: 0 0 0 1px #014f3c; }
                .od-step.is-current .od-dot { background: #ceb256; box-shadow: 0 0 0 2px #ceb256; }
                .od-step-label { font-size: 12.5px; color: #9ca3af; line-height: 1.2; }
                .od-step.is-done .od-step-label { color: #014f3c; }
                .od-step.is-current .od-step-label { color: #1a1a1a; font-weight: 700; }

                /* Mobile: horizontal tracker */
                @media (max-width: 820px) {
                    .od-steps { flex-direction: row; }
                    .od-step {
                        flex: 1;
                        flex-direction: column;
                        gap: 5px;
                        padding-bottom: 0;
                        text-align: center;
                    }
                    .od-step::before {
                        left: 50%;
                        right: -50%;
                        top: 8px;
                        bottom: auto;
                        width: auto;
                        height: 2px;
                    }
                    .od-step-label { font-size: 10px; }
                }

                /* ---- Order items (compact) ---- */
                .od-item {
                    display: flex;
                    gap: 10px;
                    align-items: center;
                    padding: 8px;
                    border-radius: 8px;
                    margin-bottom: 8px;
                    border: 1px solid #eee;
                    background: #fff;
                }
                .od-item:last-child { margin-bottom: 0; }
                .od-item.is-cancelled { border-color: #fca5a5; background: #fff5f5; }
                .od-item img {
                    width: 75px; height: 75px;
                    object-fit: cover;
                    border-radius: 6px;
                    flex-shrink: 0;
                }
                .od-item-body { flex: 1; min-width: 0; }
                .od-item-top {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    gap: 8px;
                }
                .od-item-name {
                    font-size: 14px;
                    font-weight: 700;
                    color: #111;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .od-item.is-cancelled .od-item-name { color: #dc2626; }
                .od-pill {
                    background: #dc2626; color: #fff;
                    font-size: 10px; font-weight: 600;
                    padding: 2px 8px; border-radius: 999px;
                    flex-shrink: 0;
                }
                .od-item-meta {
                    display: flex; flex-wrap: wrap; gap: 4px 10px;
                    font-size: 12px; color: #666; margin: 2px 0;
                }
                .od-item-price { font-size: 13px; }
                .od-item-price del { color: #aaa; margin-right: 6px; font-size: 12px; }
                .od-item-price strong { color: #014f3c; }
                .od-item.is-cancelled .od-item-price strong,
                .od-item.is-cancelled .od-item-meta { color: #dc2626; }
                .od-reason { font-size: 12px; color: #dc2626; }

                /* ---- Address ---- */
                .od-address p {
                    margin: 0;
                    font-size: 13px;
                    line-height: 1.55;
                    color: #444;
                    word-break: break-word;
                    cursor: pointer;
                }
                .od-address p.is-clamped {
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .od-more {
                    background: none;
                    border: none;
                    padding: 0;
                    margin-top: 4px;
                    font-size: 12px;
                    font-weight: 600;
                    color: #014f3c;
                    cursor: pointer;
                }
                .od-more:hover { color: #ceb256; }

                /* ---- Price rows ---- */
                .od-row {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 4px 0;
                    font-size: 13.5px;
                    color: #555;
                }
                .od-row b { color: #111; font-weight: 600; }
                .od-row.is-discount b { color: #16a34a; }
                .od-total {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-top: 8px;
                    padding: 8px 10px;
                    background: #ceb256;
                    color: #fff;
                    border-radius: 6px;
                    font-size: 15px;
                    font-weight: 800;
                }

                /* ---- Thank you + order info ---- */
                .od-thanks h2 {
                    margin: 0 0 10px;
                    font-size: 16px;
                    font-weight: 700;
                    color: #1a1a1a;
                }
                .od-info {
                    display: grid;
                    grid-template-columns: repeat(6, 1fr);
                    gap: 8px;
                }
                @media (max-width: 1000px) {
                    .od-info { grid-template-columns: repeat(3, 1fr); }
                }
                @media (max-width: 560px) {
                    .od-info { grid-template-columns: repeat(2, 1fr); }
                }
                .od-info-box {
                    background: #fbf6e6;
                    border-radius: 6px;
                    padding: 6px 10px;
                    font-size: 12.5px;
                    color: #222;
                    min-width: 0;
                }
                .od-info-box span.k {
                    display: block;
                    font-size: 11px;
                    color: #8a7a3a;
                    margin-bottom: 1px;
                }
                .od-info-box .v { word-break: break-all; font-weight: 600; }
                .od-badge {
                    display: inline-block;
                    padding: 1px 9px;
                    border-radius: 999px;
                    font-size: 11.5px;
                    font-weight: 700;
                    color: #fff;
                }

                /* ---- Invoice button ---- */
                .od-actions { display: flex; justify-content: flex-end; margin-top: 14px; }
                .od-btn {
                    display: inline-flex; align-items: center; gap: 6px;
                    padding: 9px 18px;
                    border: none; border-radius: 6px;
                    background: #014f3c; color: #fff;
                    font-size: 13px; font-weight: 600;
                    cursor: pointer;
                    transition: background 0.2s;
                }
                .od-btn:hover { background: #ceb256; }
                @media (max-width: 480px) {
                    .od-actions { justify-content: stretch; }
                    .od-btn { width: 100%; justify-content: center; }
                }
            `}</style>

            <main className="main__content_wrapper">
                <div className="login__section section--padding od-section">
                    <div className="od-wrap">

                        <div className="od-grid">

                            {/* THANK YOU + ORDER INFO (2nd, below items) */}
                            <div className="od-card od-thanks">
                                <h2>
                                    ✅ Thank You! Your Order is{" "}
                                    <span style={{ color: statusColor[oredrlist.orderStatus] || '#014f3c' }}>
                                        {oredrlist.orderStatus}
                                    </span>
                                </h2>
                                <div className="od-info">
                                    <div className="od-info-box">
                                        <span className="k">Order ID</span>
                                        <span className="v" style={{ fontSize: '11.5px' }}>{oredrlist.orderId}</span>
                                    </div>
                                    <div className="od-info-box">
                                        <span className="k">Placed On</span>
                                        <span className="v">{oredrlist?.statusHistory?.[0]?.date || "N/A"}</span>
                                    </div>
                                    <div className="od-info-box">
                                        <span className="k">Status</span>
                                        <span className="od-badge" style={{ backgroundColor: statusColor[oredrlist.orderStatus] || '#014f3c' }}>
                                            {oredrlist.orderStatus}
                                        </span>
                                    </div>
                                    <div className="od-info-box">
                                        <span className="k">Payment</span>
                                        <span className="v">{oredrlist.paymentMethod}</span>
                                    </div>
                                    <div className="od-info-box">
                                        <span className="k">Total</span>
                                        <span className="v">₹{oredrlist.totalAmount?.toFixed(2)}</span>
                                    </div>
                                    <div className="od-info-box">
                                        <span className="k">Est. Delivery</span>
                                        <span className="v">{oredrlist.expectedDeliverydate || "After Shipped"}</span>
                                    </div>
                                </div>
                            </div>

                            {/* ORDER STATUS (bottom row on desktop | last on mobile) */}
                            <div className="od-card od-status">
                                <h3 className="od-card-title">📦 Order Status</h3>
                                <div className="od-current">{oredrlist.orderStatus}</div>
                                <div className="od-steps">
                                    {steps.map((step, index) => {
                                        const isDone = index <= currentIndex;
                                        const isCurrent = step === oredrlist.orderStatus;
                                        return (
                                            <div
                                                key={index}
                                                className={`od-step ${isDone ? 'is-done' : ''} ${isCurrent ? 'is-current' : ''}`}
                                            >
                                                <div className="od-dot" />
                                                <span className="od-step-label">
                                                    {step}{isCurrent && ' ✓'}
                                                </span>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            {/* ORDER ITEMS */}
                            <div className="od-card od-items">
                                <h3 className="od-card-title">🛍️ Order Items</h3>
                                {oredrlist.orderItems?.map((item, idx) => {
                                    const cancelled = item?.cancelStatus === "Cancelled";
                                    return (
                                        <div key={idx} className={`od-item ${cancelled ? 'is-cancelled' : ''}`}>
                                            {item?.variant?.images?.length > 0 && (
                                                <img
                                                    src={item.variant.images[0]}
                                                    alt={item.product?.name || item.name || "Product"}
                                                />
                                            )}
                                            <div className="od-item-body">
                                                <div className="od-item-top">
                                                    <div className="od-item-name">{item.name || item.product?.name}</div>
                                                    {cancelled && <span className="od-pill">Cancelled</span>}
                                                </div>
                                                <div className="od-item-meta">
                                                    <span>Qty: {item.quantity}</span>
                                                    <span>Size: {item.variant?.size || "N/A"}</span>
                                                    <span>Color: {item.variant?.color || "N/A"}</span>
                                                </div>
                                                <div className="od-item-price">
                                                    <del>₹{item.price?.originalPrice?.toFixed(2)}</del>
                                                    <strong>₹{item.price?.discountedPrice?.toFixed(2)}</strong>
                                                </div>
                                                {cancelled && (
                                                    <span className="od-reason">Cancel Reason:- {item.cancelReason}</span>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                            {/* DELIVERY ADDRESS */}
                            <div className="od-card od-address">
                                <h3 className="od-card-title">📍 Delivery Address</h3>
                                {(() => {
                                    const fullAddress = [
                                        oredrlist.shippingAddress?.fullName,
                                        oredrlist.shippingAddress?.address,
                                        oredrlist.shippingAddress?.houseName,
                                        oredrlist.shippingAddress?.landmark,
                                        oredrlist.shippingAddress?.city,
                                        oredrlist.shippingAddress?.state,
                                        oredrlist.shippingAddress?.pincode,
                                        oredrlist.shippingAddress?.phone,
                                    ].filter(Boolean).join(", ");
                                    return (
                                        <>
                                            <p
                                                className={showFullAddress ? 'is-open' : 'is-clamped'}
                                                onClick={() => setShowFullAddress(!showFullAddress)}
                                                title={showFullAddress ? 'Click to collapse' : 'Click to see full address'}
                                            >
                                                {fullAddress}
                                            </p>
                                            {fullAddress.length > 60 && (
                                                <button
                                                    type="button"
                                                    className="od-more"
                                                    onClick={() => setShowFullAddress(!showFullAddress)}
                                                >
                                                    {showFullAddress ? 'Show less ▲' : 'Show full address ▼'}
                                                </button>
                                            )}
                                        </>
                                    );
                                })()}
                            </div>

                            {/* PRICE SUMMARY */}
                            <div className="od-card od-price">
                                <h3 className="od-card-title">💰 Price Summary</h3>
                                <div className="od-row">
                                    <span>Subtotal</span>
                                    <b>₹{oredrlist.itemsSubtotal?.toFixed(2)}</b>
                                </div>
                                <div className="od-row">
                                    <span>Shipping</span>
                                    <b>₹{oredrlist.shippingCharge?.toFixed(2)}</b>
                                </div>
                                {oredrlist.discountApplied > 0 && (
                                    <div className="od-row is-discount">
                                        <span>Discount</span>
                                        <b>-₹{oredrlist.discountApplied?.toFixed(2)}</b>
                                    </div>
                                )}
                                <div className="od-total">
                                    <span>Total</span>
                                    <span>₹{oredrlist.totalAmount?.toFixed(2)}</span>
                                </div>
                            </div>

                        </div>

                        {/* Action Buttons (same handler) */}
                        <div className="od-actions">
                            <button onClick={handleDownloadInvoice} className="od-btn">
                                📄 Download Invoice
                            </button>
                        </div>

                    </div>
                </div>
            </main>

            <Footer />

            {/* Scroll to top */}
            <button
                onClick={handleScrollTop}
                style={{
                    position: 'fixed', bottom: '30px', right: '30px',
                    width: '48px', height: '48px', borderRadius: '50%',
                    backgroundColor: '#ceb256', color: '#fff',
                    border: 'none', zIndex: 1000, cursor: 'pointer',
                    display: isVisible ? 'flex' : 'none',
                    alignItems: 'center', justifyContent: 'center',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                }}
            >
                <svg xmlns="http://www.w3.org/2000/svg" height="22" width="22" viewBox="0 0 512 512" fill="none" stroke="currentColor" strokeWidth="48" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M112 244l144-144 144 144" />
                    <path d="M256 120v292" />
                </svg>
            </button>
        </>
    );
};

export default OrderList;